var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2568ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9332c5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_success",
    transform: "translate(-11001 21441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_successful",
    transform: "translate(10463 -21595)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 150,
    cy: 150,
    r: 150,
    transform: "translate(538 154)",
    fill: "#003fb9",
    opacity: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 115,
    cy: 115,
    r: 115,
    transform: "translate(573 189)",
    fill: "#003fb9",
    opacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4530",
    "data-name": "Group 4530",
    transform: "translate(11098.455 -21343.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7952",
    "data-name": "Path 7952",
    d: "M154,79c0,6.4-7.862,11.675-9.437,17.575-1.625,6.1,2.488,14.6-.6,19.938-3.138,5.425-12.575,6.075-16.975,10.475s-5.05,13.837-10.475,16.975c-5.338,3.088-13.837-1.025-19.938.6C90.675,146.138,85.4,154,79,154s-11.675-7.862-17.575-9.437c-6.1-1.625-14.6,2.488-19.937-.6-5.425-3.138-6.075-12.575-10.475-16.975s-13.837-5.05-16.975-10.475c-3.087-5.338,1.025-13.837-.6-19.938C11.863,90.675,4,85.4,4,79s7.863-11.675,9.438-17.575c1.625-6.1-2.488-14.6.6-19.937,3.138-5.425,12.575-6.075,16.975-10.475s5.05-13.837,10.475-16.975c5.338-3.087,13.838,1.025,19.938-.6C67.325,11.863,72.6,4,79,4s11.675,7.863,17.575,9.438c6.1,1.625,14.6-2.488,19.938.6,5.425,3.138,6.075,12.575,10.475,16.975s13.837,5.05,16.975,10.475c3.088,5.338-1.025,13.838.6,19.938C146.138,67.325,154,72.6,154,79Z",
    transform: "translate(-26.455 -26.455)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7953",
    "data-name": "Path 7953",
    d: "M91.34,36.12,58.5,68.96,46.66,57.13a6.583,6.583,0,0,0-9.31,9.31L53.96,83.05a6.41,6.41,0,0,0,9.06,0l37.62-37.62a6.58,6.58,0,0,0-9.3-9.31Z",
    transform: "translate(-16.45 -7.014)",
    fill: "#fffcee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccess);
export default __webpack_public_path__ + "static/media/ic_success.c8d54b69c4036268dfeca44f83f6384e.svg";
export { ForwardRef as ReactComponent };